import { useEffect } from "react";
import { toast } from "sonner";

// 🟢 INFRA — exibe as mensagens flash do Rails como toasts.
//
// Usado pelas duas SPAs (pública e logada), que recebem o flash via
// `data-parameters` no elemento #root.
//
// O `id` fixo por tipo é essencial: em desenvolvimento o <React.StrictMode>
// monta cada componente duas vezes de propósito (para expor efeitos não
// idempotentes), então um toast() sem id apareceria duplicado. Com id estável,
// o sonner reaproveita o mesmo toast em vez de empilhar outro.
export default function useFlashToasts(flash = {}) {
  const { notice, alert } = flash;

  useEffect(() => {
    if (notice) toast.info(notice, { id: "flash-notice" });
    if (alert) toast.warning(alert, { id: "flash-alert" });
  }, [notice, alert]);
}
